import React from 'react'
import parser from 'html-react-parser'

export default function Content10({ data }) {
    const { content10ButtonLink, content10ButtonText, content10LeftText, content10RightText, content10Title, content10ButtonExternalLink } = data
    return (
        <div className='dana-sec-1 panel-space-70'>
            <div className='container sm-container'>
                <div className='row'>
                    <div className='col-md-6'>
                        <p>{content10LeftText && parser(content10LeftText)}</p>
                    </div>
                    <div className='col-md-6'>
                        <p>{content10RightText && parser(content10RightText)}</p>
                    </div>
                    <div className='col-md-12 text-center dana-reqest-btn-sec'>
                        {content10ButtonExternalLink ? (
                            <a href={content10ButtonExternalLink} className="btn blue-btn">
                                {content10ButtonText}
                            </a>
                        ) : content10ButtonLink ? (
                            <a
                                href={`mailto:${content10ButtonLink}`}
                                className='btn blue-btn'
                            >
                                {content10ButtonText}
                            </a>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
